import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { trackEndpointAccess, trackEndpointResponseTime } from "src/utils/analyticsCapFirebase";
import { fetchWithCache } from "src/utils/cacheUtils";

interface ErrorResponse {
  detail?: string;
  message?: string;
}

export const getRankings = async (
  authId,
  userDataPlatform,
  leagueIdPlatform,
  teamName,
  pocTokens,
  accessAuthToken,
  signal?: AbortSignal,
  yahooToken?: string,
  forceRefresh = false,
  calculatorSettings?: any
): Promise<any> => {
  try {
    const startedAt = Date.now();
    const url = `${process.env.REACT_APP_BACKEND_URL}/functions/player_rankings`;
    // Cache key based on league and user for better tracking
    const cacheKey = `rankings-${leagueIdPlatform}-${userDataPlatform.user_id}`;

    // console.log("TOKEN DE GET RAKINGS", token);
    // console.log("TOKEN accessAuthToken", accessAuthToken);

    const requestData: any = {
      league_integration: {
        leagueToken: userDataPlatform.integration_name === "yahoo" ? yahooToken : userDataPlatform.token,
        pocToken: pocTokens,
        user_id: userDataPlatform.user_id,
        league_id: leagueIdPlatform,
        integration_name: userDataPlatform.integration_name,
        force_refresh: forceRefresh,
        // common_data: commonLeagueData,
      },
      //   response_settings: {
      //     persona_input: "standard",
      //     max_words: 0,
      //   },
      sport: "NFL",
      //   model: "RotoGPT 4.0",
      // Add calculator_settings if provided (from LeagueSettings component)
      ...(calculatorSettings && { calculator_settings: calculatorSettings }),
    };

    // If the platform is ESPN, add the specific fields it requires
    if (userDataPlatform.integration_name === "espn") {
      requestData.league_integration.swid = userDataPlatform.swid;
      requestData.league_integration.espn_s2 = userDataPlatform.s2;
    }

    // console.log("Rankings REQUEST DATA", requestData);

    const options: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
        "X-Skip-Cache": "true",
      },
      body: JSON.stringify(requestData),
      signal,
      credentials: "include",
    };

    const { data, fromCache, ok } = await fetchWithCache(url, options, leagueIdPlatform, userDataPlatform.user_id, authId, forceRefresh);

    // --- TRACK EVENT ON REAL EXECUTION (NOT CACHE) ---
    if (!fromCache && ok) {
      await trackEndpointAccess(authId, userDataPlatform.integration_name, leagueIdPlatform, teamName, "rankings");
      void trackEndpointResponseTime(authId, "rankings", (Date.now() - startedAt) / 1000, userDataPlatform.integration_name, leagueIdPlatform);
    }

    // if (fromCache) {
    //   console.log(`[Rankings Cache] HIT for: ${cacheKey}`);
    // } else {
    //   console.log(`[Rankings Cache] MISS for: ${cacheKey}`);
    // }

    if (!ok) {
      const errorData = data as ErrorResponse;
      throw new Error(errorData.detail || errorData.message);
    }

    return data;
  } catch (error) {
    // console.error("Something went wrong when getting rankings data", error);
    // showErrorToast("Something went wrong when getting rankings data");
    if (error.name === "AbortError") {
      console.log("Request was aborted");
      return;
    }
    console.error("Error in getRankings:", error);
    showErrorToast(error.message);
    throw error;
  }
};
